import { FC, PropsWithChildren } from 'react';

import { SModalFooter } from './Modal.styled';

const ModalFooter: FC<PropsWithChildren> = ({ children }) => {
  return <SModalFooter>{children}</SModalFooter>;
};

export default ModalFooter;
